import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  SOLD_BY_REQUEST,
  SOLD_BY_SUCCESS,
  SOLD_BY_FAILED,
  SOLD_BY_CREATE,
  SOLD_BY_CREATE_SUCCESS,
  SOLD_BY_CREATE_FAILED,
  SOLD_BY_DELETE,
  SOLD_BY_DELETE_SUCCESS,
  SOLD_BY_DELETE_FAILED,
  SOLD_BY_EDIT,
  SOLD_BY_EDIT_SUCCESS,
  SOLD_BY_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * SoldBy Actions
 */

function* fetchSoldBy({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Master/api/SoldBy/GetSoldBy`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: SOLD_BY_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: SOLD_BY_FAILED, payload: error.response });
    }
  }
}

function* createSoldBy(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/SoldBy/CreateSoldBy`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: SOLD_BY_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: SOLD_BY_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editSoldBy(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/SoldBy/UpdateSoldBy`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: SOLD_BY_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: SOLD_BY_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteSoldBy(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/SoldBy/RemoveSoldBy?SoldById=${encodeURIComponent(action.payload.SoldById)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: SOLD_BY_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: SOLD_BY_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootSoldByList() {
  yield all([
    takeLatest(SOLD_BY_REQUEST, fetchSoldBy),
    takeLatest(SOLD_BY_CREATE, createSoldBy),
    takeLatest(SOLD_BY_DELETE, deleteSoldBy),
    takeLatest(SOLD_BY_EDIT, editSoldBy),
  ]);
}